import { getDataFromLocalStorage, getTokenFromLocalStorage } from 'utils/LocalStorage';
import instance from '../../axios/index';
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';
export const signInUser = async (payload) => {
  try {
    let response = await instance.post('/common/login', payload);
    return response;
  } catch (err) {
    return err.response || err;
  }
};
export const getAccessToken = async () => {
  try {
    const refreshToken = getDataFromLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
    const authHeader = JSON.stringify({ refreshToken }); 
    let response = await instance.post(
      '/common/get_access_token',
      {},
      {
        headers: {
          authorization: authHeader,
          currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response || err;
  }
};
